import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useHistory } from 'react-router';
import { Loader } from '../../../../__legacy__/components/Loader';
import { EnableFor } from '../../../../__legacy__/containers/EnableForRole';
import { useAnnotationPermissions } from '../../../../__legacy__/modules/annotation/annotation.permissions';
import { Home } from '../../../../__legacy__/routes/config/Home';
import { S_Card } from '../../../../design/card/card/S_Cards';

interface IReviewOverviewWidgetProps {
  isLoading: boolean;
  toReviewCount: number;
  acceptedCount: number;
  rejectedCount: number;
  projectId: string;
  workspaceId: string;
}

export const ReviewOverview = observer((props: IReviewOverviewWidgetProps): ReactElement => {
  const { t } = useTranslator();
  const history = useHistory();
  const permissions = useAnnotationPermissions();

  const total = props.acceptedCount + props.toReviewCount;
  const percentage = total === 0 ? 0 : ((props.acceptedCount / total) * 100).toFixed(2);

  return (
    <S_Card className='overview-card card-with-list'>
      <Loader isLoading={props.isLoading}>
        <div className='info'>
          <h5>
            {t('review_progress')} {props.acceptedCount}/{total} ({percentage}%)
          </h5>
          <div className='list-row first'>
            <div className='left'>{t('waiting_for_review')}</div>
            <div className='right'>{props.toReviewCount}</div>
          </div>
          <div className='list-row'>
            <div className='left'>{t('waiting_for_correction')}</div>
            <div className='right'>{props.rejectedCount}</div>
          </div>
        </div>
        <div className='bottom'>
          <EnableFor
            hasPermission={permissions.canSeeReviewButton(props.projectId)}
            hideWhenNoAccess
          >
            <EnableFor hasPermission={permissions.canReview(props.projectId)}>
              <Button
                onClick={() => {
                  history.push(Home.Annotations.Review.withParams({ projectId: props.projectId, workspaceId: props.workspaceId }));
                }}
              >
                {t('start_review')}
              </Button>
            </EnableFor>
          </EnableFor>
        </div>
      </Loader>
    </S_Card>
  );
});
